import {
  Building2,
  Smartphone,
  Cable,
  Boxes,
  Globe2,
  ArrowUpRight,
} from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useI18n } from "@/i18n";

const ICONS = [Building2, Smartphone, Cable, Boxes, Globe2];
const SPANS = ["lg:col-span-2 lg:row-span-2", "", "", "", ""];

export default function About() {
  const { t } = useI18n();
  const cards = t("about.cards") || [];
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <SectionHeading
              testId="about-heading"
              eyebrow={t("about.eyebrow")}
              title={
                <>
                  {t("about.title_a")}{" "}
                  <span className="text-gradient-brand">{t("about.title_b")}</span>
                  {t("about.title_dot")}
                </>
              }
              subtitle={t("about.subtitle")}
            />
            <p className="mt-6 max-w-md text-[14.5px] text-[#A8A8B3] reveal">
              {t("about.paragraph")}
            </p>
            <a
              href="#contact"
              data-testid="about-cta"
              className="mt-8 inline-flex items-center gap-1.5 text-white font-medium reveal group"
            >
              <span className="border-b border-white/30 group-hover:border-white pb-0.5">
                {t("about.cta")}
              </span>
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 lg:grid-cols-3 grid-rows-[auto] gap-4 md:gap-5">
              {cards.map((card, i) => {
                const Icon = ICONS[i] || Building2;
                return (
                  <div
                    key={i}
                    data-testid={`about-card-${i}`}
                    className={`glass-card rounded-3xl p-6 md:p-7 ${SPANS[i] || ""} reveal`}
                    style={{ transitionDelay: `${i * 80}ms` }}
                  >
                    <div className="icon-bubble mb-5">
                      <Icon className="w-5 h-5" />
                    </div>
                    <h3 className="font-display text-[17px] md:text-[19px] font-semibold tracking-tight text-white">
                      {card.title}
                    </h3>
                    <p className="mt-2 text-[13.5px] md:text-[14px] text-[#A8A8B3] leading-relaxed">
                      {card.body}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
